export const parseUiPage = (raw: string | string[] | undefined): number => {
  const value = Array.isArray(raw) ? raw[0] : raw;
  const parsed = Number(value);

  if (!Number.isFinite(parsed) || parsed < 1) {
    return 1;
  }

  return Math.floor(parsed);
};

export const toApiPage = (uiPage: number): number => Math.max(0, uiPage - 1);

export const blogListingHref = (
  pathname: string,
  page: number,
  extra?: Record<string, string>
): string => {
  const params = new URLSearchParams();

  if (extra) {
    Object.entries(extra).forEach(([key, value]) => {
      if (value) {
        params.set(key, value);
      }
    });
  }

  if (page > 1) {
    params.set('page', String(page));
  }

  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
};

export const blogTagHref = (tag: string): string =>
  `/blog/tag?tag=${encodeURIComponent(tag)}`;
